import { create } from 'zustand';

/**
 * 화면의 자동저장 상태.
 * - pending: 저장 대기 중인 입력 수. 0이 아니면 앱 업데이트(새로고침)를 막는다 (계획서 §17-8).
 * - flushers: 화면에 있는 모든 자동저장기의 "즉시 저장" 함수.
 *   처리·승인 같은 버튼은 실행 전에 flushAll()로 화면의 입력을 먼저 저장한다
 *   (방금 입력한 내용이 저장되기 전에 다음 단계가 실행되는 일을 막는다).
 */
type Flush = () => Promise<void>;
type SaveState = { pending: number; inc: () => void; dec: () => void };

export const useSaves = create<SaveState>((set) => ({
  pending: 0,
  inc: () => set((s) => ({ pending: s.pending + 1 })),
  dec: () => set((s) => ({ pending: Math.max(0, s.pending - 1) })),
}));

const flushers = new Set<Flush>();

export function registerFlusher(fn: Flush): () => void {
  flushers.add(fn);
  return () => flushers.delete(fn);
}

export async function flushAll(): Promise<void> {
  await Promise.all([...flushers].map((f) => f()));
}
